<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-blue-400 hover:text-blue-600" :href="route('properties')"><icon name="home" class="w-6 h-6 -mt-1 mr-2 inline-block fill-blue-400" />Inmuebles</inertia-link>
      <span class="text-blue-400 font-medium">/</span>
      {{ form.nombre }}
      <span v-if="form.patrocinada" class="bg-blue-500 text-sm text-white px-2 py-1 rounded-md ml-2"> Patrocinada <icon name="star" class="w-6 h-6 -mt-1  inline-block fill-white" /> </span>
    </h1>
    <!-- Pirate Tabs -->
    <button :class="tab === 0 ? 'bg-white text-gray-800' : ''" class="btn-pirata ml-auto" tabindex="-1" type="button" @click="changeTab(0)">Informacion</button>
    <button v-if="form.operacion === 1" :class="tab === 1 ? 'bg-white text-gray-800' : ''" class="btn-pirata ml-auto" tabindex="-1" type="button" @click="changeTab(1)">Precios</button>
    <button v-if="form.operacion === 1" :class="tab === 2 ? 'bg-white text-gray-800' : ''" class="btn-pirata ml-auto" tabindex="-1" type="button" @click="changeTab(2)">Calendario</button>
    <button :class="tab === 3 ? 'bg-white text-gray-800' : ''" class="btn-pirata ml-auto" tabindex="-1" type="button" @click="changeTab(3)">Fotos</button>

    <!-- information -->
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl" v-if="tab == 0">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.nombre" :error="form.errors.nombre" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre de la propiedad" />
          <label class="mr-6 mb-4 select-none flex items-center" for="desactivada">
            <input id="desactivada" v-model="form.desactivada" class="mr-1" type="checkbox" />
            <span class="text-check">Propiedad Desactivada</span>
          </label>
          <select-input v-model="form.ID_duenio" :error="form.errors.ID_duenio" class="pr-6 pb-8 w-full lg:w-1/2" label="Propietario">
            <option :value="null" />
            <option v-for="user in users" :key="user.ID" :value="user.ID">{{ user.usuario }} - {{ user.nombre }}</option>
          </select-input>
          <select-input v-model="form.operacion" :error="form.errors.operacion" class="pr-6 pb-8 w-full lg:w-1/2" label="Tipo de operacion">
            <option :value="null" />
            <option value="1">Alquiler</option>
            <option value="2">Venta</option>
            <option value="3">Transitorio</option>
          </select-input>
          <select-input v-model="form.tipo_inmueble" :error="form.errors.tipo_inmueble" class="pr-6 pb-8 w-full lg:w-1/2" label="Tipo Inmueble">
            <option :value="null" />
            <option value="1">Casa/Cabaña</option>
            <option value="2">Apartamento</option>
            <option value="3">Hotel/Posada</option>
            <option value="4">Hostel/Camping</option>
            <option value="5">Terreno</option>
            <option value="6">Chacra</option>
          </select-input>
          <select-input v-model="form.zona" :error="form.errors.zona" class="pr-6 pb-8 w-full lg:w-1/2" label="Zona">
            <option :value="null" />
            <option value="1">La Pedrera</option>
            <option value="3">Punta Rubia</option>
            <option value="2">San Sebastián</option>
            <option value="5">Arachania</option>
            <option value="4">Santa Isabel</option>
            <option value="6">Tajamares de La Pedrera</option>
            <option value="11">La Serena Golf</option>
            <option value="7">San Antonio</option>
            <option value="8">Pueblo Nuevo</option>
            <option value="9">Atlántica</option>
            <option value="10">Oceanía del Polonio</option>
            <option value="12">La Paloma</option>
            <option value="13">Zona rural</option>
          </select-input>
          <text-input v-model="form.mapongo" placeholder="-34.591327,-54.127965" :error="form.errors.mapongo" class="pr-6 pb-8 w-full lg:w-1/2" label="Coordenadas de Mapa" />
          <a href="http://www.google.com/maps?ll=-34.591327,-54.127965&spn=0.007092,0.016512&t=m&z=17" class="map" target="_blank">Codigo del mapa</a><br />
          <div class="w-full">
            <label class="mr-6 mb-4 select-none flex items-center" for="patrocinada">
              <input id="patrocinada" v-model="form.patrocinada" class="mr-1" type="checkbox" />
              <span class="text-check">Propiedad Patrocinada</span>
            </label>
          </div>

          <h2 class="w-full">Informacion de Propiedad y Contacto</h2>
          <div class="rich-content mb-4">
            <label class="mb-2" for="">Descripcion</label>
            <!-- {{form.descripcion}} -->
            <vue-editor class="w-full" v-model="form.descripcion" :editor-toolbar="customToolbar" :error="form.errors.descripcion" />
          </div>
          <div class="rich-content">
            <label class="mb-2" for="">Descripcion Corta</label>
            <vue-editor class="w-full" v-model="form.descripcion_corta" :error="form.errors.descripcion_corta" :editor-toolbar="customToolbar" />
          </div>
          <div class="rich-content">
            <label class="mb-2" for="">Información de contacto</label>
            <vue-editor class="w-full" v-model="form.informe_contacto" :error="form.errors.informe_contacto" :editor-toolbar="customToolbar" />
          </div>
          <!-- <text-input v-model="form.descripcion"  class="pr-6 pb-8 w-full lg:w-1/2" label="Descripción larga" />            
              <text-input v-model="form.descripcion_corta"  class="pr-6 pb-8 w-full lg:w-1/2" label="Descripción corta" />             -->
          <!-- <text-input v-model="form.informe_contacto" :error="form.errors.informe_contacto" class="pr-6 pb-8 w-full lg:w-1/2" label="Información de contacto" /> -->
          <text-input v-model="form.email_contacto" :error="form.errors.email_contacto" class="pr-6 pb-8 w-full lg:w-1/2" label="Email de contacto" />

          <text-input v-model="form.whatsapp" :error="form.errors.whatsapp" class="pr-6 pb-8 w-full lg:w-1/2" label="Whatsapp" />

          <!-- 
             $table->string('nombre', 200);
            $table->integer('ID_duenio'); -->
          <!-- <text-area-input v-model="form.description" :error="form.errors.description" class="pr-6 pb-8 w-full lg:w-1/2" label="Descripcion" />
            <text-area-input v-model="form.en_description" :error="form.errors.en_description" class="pr-6 pb-8 w-full lg:w-1/2" label="Descripcion en ingles" /> -->
        </div>
        <div v-if="form.operacion === 1" class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <h2 class="w-full">Comodidades</h2>
          <select-input v-model="form.capacidad" :error="form.errors.capacidad" class="pr-6 pb-8 w-full lg:w-1/2" label="Capacidad">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
          </select-input>
          <select-input v-model="form.dormitorios" :error="form.errors.dormitorios" class="pr-6 pb-8 w-full lg:w-1/2" label="Dormitorios">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </select-input>
          <select-input v-model="form.banios" :error="form.errors.banios" class="pr-6 pb-8 w-full lg:w-1/2" label="Baños">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </select-input>
          <select-input v-model="form.banio_suite" :error="form.errors.banio_suite" class="pr-6 pb-8 w-full lg:w-1/2" label="Baños en Suite">
            <option value="0">No</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </select-input>
          <select-input v-model="form.cubiertos" :error="form.errors.cubiertos" class="pr-6 pb-8 w-full lg:w-1/2" label="Cubiertos y vajillas">
            <option value="1">1 persona</option>
            <option value="2">2 personas</option>
            <option value="3">3 personas</option>
            <option value="4">4 personas</option>
            <option value="5">5 personas</option>
            <option value="6">6 personas</option>
            <option value="7">7 personas</option>
            <option value="8">8 personas</option>
            <option value="69">más de 8</option>
          </select-input>
          <label class="mr-6 mb-4 select-none flex items-center" for="sabanas">
            <input id="sabanas" v-model="form.sabanas" class="mr-1" type="checkbox" />
            <span class="">Incluye sabanas</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="mascotas">
            <input id="mascotas" v-model="form.mascotas" class="mr-1" type="checkbox" />
            <span class="text-check">Acepta mascotas</span>
          </label>
          <h2 class="w-full">Equipamiento</h2>
          <label class="mr-6 mb-4 select-none flex items-center" for="wifi">
            <input id="wifi" v-model="form.wifi" class="mr-1" type="checkbox" />
            <span class="text-check">Wifi</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="parrillero">
            <input id="parrillero" v-model="form.parrillero" class="mr-1" type="checkbox" />
            <span class="text-check">Parrillero</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="direct">
            <input id="direct" v-model="form.direct" class="mr-1" type="checkbox" />
            <span class="text-check">Direct TV</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="piscina">
            <input id="piscina" v-model="form.piscina" class="mr-1" type="checkbox" />
            <span class="text-check">Piscina</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="aire">
            <input id="aire" v-model="form.aire" class="mr-1" type="checkbox" />
            <span class="text-check">Aire Acondicionado</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="estufa">
            <input id="estufa" v-model="form.estufa" class="mr-1" type="checkbox" />
            <span class="text-check">Estufa</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="cerco">
            <input id="cerco" v-model="form.cerco" class="mr-1" type="checkbox" />
            <span class="text-check">Cerco</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="jacuzzi">
            <input id="jacuzzi" v-model="form.jacuzzi" class="mr-1" type="checkbox" />
            <span class="text-check">Jacuzzi</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="alarma">
            <input id="alarma" v-model="form.alarma" class="mr-1" type="checkbox" />
            <span class="text-check">Alarma</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="rejas">
            <input id="rejas" v-model="form.rejas" class="mr-1" type="checkbox" />
            <span class="text-check">Rejas</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="lavarropas">
            <input id="lavarropas" v-model="form.lavarropas" class="mr-1" type="checkbox" />
            <span class="text-check">lavarropas</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="cochera">
            <input id="cochera" v-model="form.cochera" class="mr-1" type="checkbox" />
            <span class="text-check">Cochera</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="cofre">
            <input id="cofre" v-model="form.cofre" class="mr-1" type="checkbox" />
            <span class="text-check">Cofre de Seguridad</span>
          </label>

          <h2 class="w-full">Destaques</h2>
          <select-input v-model="form.alquiler_alta" :error="form.errors.alquiler_alta" class="pr-6 pb-8 w-full lg:w-1/2" label="Período mínimo de alquiler en alta temp.">
            <option value="">No alquila</option>
            <option value="día">día</option>
            <option value="fin de semana">fin de semana</option>
            <option value="semana">semana</option>
            <option value="10 días">10 días</option>
            <option value="quincena">quincena</option>
          </select-input>
          <select-input v-model="form.alquiler_baja" :error="form.errors.alquiler_baja" class="pr-6 pb-8 w-full lg:w-1/2" label="Período mínimo de alquiler en baja temp.">
            <option value="">No alquila</option>
            <option value="día">día</option>
            <option value="fin de semana">fin de semana</option>
            <option value="semana">semana</option>
            <option value="10 días">10 días</option>
            <option value="quincena">quincena</option>
          </select-input>
          <label class="mr-6 mb-4 select-none flex items-center" for="jovenes">
            <input id="jovenes" v-model="form.jovenes" class="mr-1" type="checkbox" />
            <span class="text-check">Alquila a Jovenes</span>
          </label>

          <h2 class="w-full">Categorias</h2>
          <label class="mr-6 mb-4 select-none flex items-center" for="vista_mar">
            <input id="vista_mar" v-model="form.vista_mar" class="mr-1" type="checkbox" />
            <span class="text-check">Vista al Mar</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="oceanview">
            <input id="oceanview" v-model="form.oceanview" class="mr-1" type="checkbox" />
            <span class="text-check">Vista al Mar(new)</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="featured">
            <input id="featured" v-model="form.featured" class="mr-1" type="checkbox" />
            <span class="text-check">Casa Destacada</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="cheap">
            <input id="cheap" v-model="form.cheap" class="mr-1" type="checkbox" />
            <span class="text-check">Calidad/Precio</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="architecture">
            <input id="architecture" v-model="form.architecture" class="mr-1" type="checkbox" />
            <span class="text-check">Arquitectura</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="nature">
            <input id="nature" v-model="form.nature" class="mr-1" type="checkbox" />
            <span class="text-check">Lejos del ruido</span>
          </label>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Inmueble</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Actualizar Inmueble</loading-button>
        </div>
      </form>
    </div>

    <!-- Prices -->
    <div class="bg-white rounded-md shadow overflow-hidden w-full prices" v-if="tab == 1">
      <!-- Importante: Ingresar precios en d?ares americanos y no ingresar otra cosa que n?meros en los casilleros. -->
      <h2 class="-mr-8 w-full">Noviembre</h2>
      <div class="p-8 -mr-6 -mb-8 flex flex-col md:flex-row">
        <text-input v-model="internalPrices.nov[0]" type="number" class="pr-6 pb-8" label="Día Primera Quincena" />
        <text-input v-model="internalPrices.nov[1]" type="number" class="pr-6 pb-8" label="Primera Quincena" />
        <text-input v-model="internalPrices.nov[2]" type="number" class="pr-6 pb-8" label="Segunda Quincena" />
        <text-input v-model="internalPrices.nov[3]" type="number" class="pr-6 pb-8" label="Mes Completo " />
        <text-input v-model="internalPrices.nov[4]" type="number" class="pr-6 pb-8" label="Día Segunda Quincena" />
      </div>
      <h2 class="-mr-8 w-full">Diciembre</h2>
      <div class="p-8 -mr-6 -mb-8 flex flex-col md:flex-row">
        <text-input v-model="internalPrices.dic[0]" type="number" class="pr-6 pb-8" label="Día Primera Quincena" />
        <text-input v-model="internalPrices.dic[1]" type="number" class="pr-6 pb-8" label="Primera Quincena" />
        <text-input v-model="internalPrices.dic[2]" type="number" class="pr-6 pb-8" label="Segunda Quincena" />
        <text-input v-model="internalPrices.dic[3]" type="number" class="pr-6 pb-8" label="Mes Completo " />
        <text-input v-model="internalPrices.dic[4]" type="number" class="pr-6 pb-8" label="Día Segunda Quincena" />
      </div>
      <h2 class="-mr-8 w-full">Enero</h2>
      <div class="p-8 -mr-6 -mb-8 flex flex-col md:flex-row">
        <text-input v-model="internalPrices.ene[0]" type="number" class="pr-6 pb-8" label="Día Primera Quincena" />
        <text-input v-model="internalPrices.ene[1]" type="number" class="pr-6 pb-8" label="Primera Quincena" />
        <text-input v-model="internalPrices.ene[2]" type="number" class="pr-6 pb-8" label="Segunda Quincena" />
        <text-input v-model="internalPrices.ene[3]" type="number" class="pr-6 pb-8" label="Mes Completo " />
        <text-input v-model="internalPrices.ene[4]" type="number" class="pr-6 pb-8" label="Día Segunda Quincena" />
      </div>
      <h2 class="-mr-8 w-full">Febrero</h2>
      <div class="p-8 -mr-6 -mb-8 flex flex-col md:flex-row">
        <text-input v-model="internalPrices.feb[0]" type="number" class="pr-6 pb-8" label="Día Primera Quincena" />
        <text-input v-model="internalPrices.feb[1]" type="number" class="pr-6 pb-8" label="Primera Quincena" />
        <text-input v-model="internalPrices.feb[2]" type="number" class="pr-6 pb-8" label="Segunda Quincena" />
        <text-input v-model="internalPrices.feb[3]" type="number" class="pr-6 pb-8" label="Mes Completo " />
        <text-input v-model="internalPrices.feb[4]" type="number" class="pr-6 pb-8" label="Día Segunda Quincena" />
      </div>
      <h2 class="-mr-8 w-full">Marzo</h2>
      <div class="p-8 -mr-6 -mb-8 flex flex-col md:flex-row">
        <text-input v-model="internalPrices.mar[0]" type="number" class="pr-6 pb-8" label="Día Primera Quincena" />
        <text-input v-model="internalPrices.mar[1]" type="number" class="pr-6 pb-8" label="Primera Quincena" />
        <text-input v-model="internalPrices.mar[2]" type="number" class="pr-6 pb-8" label="Segunda Quincena" />
        <text-input v-model="internalPrices.mar[3]" type="number" class="pr-6 pb-8" label="Mes Completo " />
        <text-input v-model="internalPrices.mar[4]" type="number" class="pr-6 pb-8" label="Día Segunda Quincena" />
      </div>
      <h2 class="-mr-8 w-full">Abril</h2>
      <div class="p-8 -mr-6 -mb-8 flex flex-col md:flex-row">
        <text-input v-model="internalPrices.abr[0]" type="number" class="pr-6 pb-8" label="Día Primera Quincena" />
        <text-input v-model="internalPrices.abr[1]" type="number" class="pr-6 pb-8" label="Primera Quincena" />
        <text-input v-model="internalPrices.abr[2]" type="number" class="pr-6 pb-8" label="Segunda Quincena" />
        <text-input v-model="internalPrices.abr[3]" type="number" class="pr-6 pb-8" label="Mes Completo " />
        <text-input v-model="internalPrices.abr[4]" type="number" class="pr-6 pb-8" label="Día Segunda Quincena" />
      </div>
      <h2 class="-mr-8 w-full">Semana de Carnaval</h2>
      <div class="p-8 -mr-6 -mb-8 flex flex-col md:flex-row">
        <text-input class="pr-6 pb-8" v-model="internalPrices.carnaval[0]" type="number" label="Por Día" />
        <text-input class="pr-6 pb-8" v-model="internalPrices.carnaval[1]" type="number" label="Semana Completa" />
      </div>
      <h2 class="-mr-8 w-full">Semana de turismo/pascuas</h2>
      <div class="p-8 -mr-6 -mb-8 flex flex-col md:flex-row">
        <text-input class="pr-6 pb-8" type="number" v-model="internalPrices.turismo[0]" label="Por Día" />
        <text-input class="pr-6 pb-8" type="number" v-model="internalPrices.turismo[1]" label="Semana Completa" />
      </div>
      <h2 class="-mr-8 w-full">Temporada baja</h2>
      <div class="p-8 -mr-6 -mb-8 flex flex-col md:flex-row">
        <text-input class="pr-6 pb-8" min="0" type="number" v-model="internalPrices.baja[0]" label="Por Día" />
        <text-input class="pr-6 pb-8" type="number" v-model="internalPrices.baja[1]" label="Semana Completa" />
      </div>
      <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
        <!-- <button class="w-1/2 flex items-center justify-center rounded-md bg-blagreeck text-white" type="submit">Buy now</button> -->
        <!-- <button class="bg-green-700 hover:bg-green-500 text-white font-bold py-3 px-6 rounded" @click="savePrices">Salvar Precios</button> -->

        <button :disabled="form.processing" class="flex items-center bg-green-700 hover:bg-green-500 text-white font-bold py-3 px-6 rounded" @click="savePrices">
          <div v-if="form.processing" class="btn-spinner mr-2" />
          {{ form.processing ? "Salvando Precios..." : "Salvar Precios" }}
        </button>
      </div>
    </div>

    <!-- Calendar -->
    <div class="bg-white rounded-md shadow overflow-hidden" v-if="tab == 2">
      <div class="p-8 -mr-6">
        <h1 class="mb-4 font-bold text-3xl">
          <span class="text-blue-400 font-medium">Calendario {{ year }} </span>
        </h1>

        <div class="flex flex-row mb-3">
          <button :class="actionYear == year ? 'bg-blue-400' : 'bg-blue-200 '" class="hover:bg-blue-500 mr-1 text-white font-bold py-3 px-6 rounded" @click="setYear(actionYear)">
            {{ actionYear }}
          </button>
          <button :class="year == nextYear ? 'bg-blue-400' : 'bg-blue-200 '" class="hover:bg-blue-500 text-white font-bold py-3 px-6 rounded" @click="setYear(nextYear)">
            {{ nextYear }}
          </button>
        </div>

        <YearCalendar v-model="year" :activeDates.sync="activeDates" @toggleDate="toggleDate" lang="es" :showYearSelector="showYearSelector"></YearCalendar>
      </div>
      <div class="p-8">
        <button @click="saveCalendar" class="bg-green-700 hover:bg-green-500 text-white font-bold py-3 px-6 rounded">Salvar Calendario</button>
      </div>
    </div>

    <!-- Fotos -->
    <div class="bg-white rounded-md shadow overflow-hidden" v-if="tab == 3">
      <div class="p-8 pb-0 flex flex-wrap">
        <h1 class="font-bold text-3xl">
          <span class="text-blue-400 font-medium">Fotos</span>
        </h1>
      </div>
      <form @submit.prevent="uploadImage">
        <div class="flex w-full items-center justify-center bg-grey-lighter">
          <label
            class="w-64 flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg shadow-lg tracking-wide uppercase border border-blue-400 cursor-pointer hover:bg-blue-400 hover:text-white"
          >
            <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
            </svg>
            <span class="mt-2 text-base leading-normal">Seleccione las imagenes</span>

            <input type="file" class="hidden" multiple accept="image/png, image/gif, image/jpeg" @input="pictureForm.picture = $event.target.files" />
          </label>
        </div>
        <div class="image-up py-6 px-4 bg-blue-100 mt-3" v-if="pictureForm.picture">
          <div class="flex flex-wrap gap-4">
            <div class="item" v-for="preloader in pictureForm.picture" :key="preloader.name">
              <img :src="createObjectURL(preloader)" style="max-width: 150px" :title="preloader.name" />
            </div>
          </div>

          <progress v-if="pictureForm.progress" :value="pictureForm.progress.percentage" max="100">{{ pictureForm.progress.percentage }}%</progress>

          <button
            type="submit"
            class="inline-block font-bold py-3 px-6 mt-2 px-3 py-2 text-center text-white transition bg-blue-500 rounded-sm shadow hover:shadow-lg hover:bg-green-600 focus:outline-none waves-effect"
          >
            Subir
          </button>
          <a type="cancel" href="javascript:;" v-on:click="pictureForm.reset()" class="inline-block py-3 mt-2 text-center text-red-700 transition">Cancelar</a>
        </div>
      </form>

      <div class="p-8 flex flex-wrap">
        <draggable class="list-group" tag="div" v-model="pictures" v-bind="dragOptions">
          <transition-group class="flex flex-wrap">
            <div v-for="element in pictures" :key="element.ID" class="picturehome list-group-item m-2">
              <!-- <img :src="element.full_url" alt="" style="max-width: 200px"> -->
              <!-- <img :src="'/img/inmuebles/' + property.ID + '_' + element.ID + '.jpg'" alt="" style="max-width: 200px" /> -->
              <img v-if="!element.full_url" :src="'https://lapedrera.com.uy/img/inmuebles/' + property.ID + '_' + element.ID + '.jpg'" alt="" style="max-width: 200px" />
              <img v-if="element.full_url" :src="element.full_url" alt="" style="max-width: 200px" />

              <button
                @click="deletePicture(element.ID)"
                class="inline-block p-3 text-center text-white transition bg-red-500 rounded-full shadow ripple hover:shadow-lg hover:bg-red-600 focus:outline-none waves-effect"
              >
                <svg class="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>
          </transition-group>
        </draggable>
      </div>
      <div class="p-8">
        <button :disabled="form.processing" class="flex items-center bg-green-700 hover:bg-green-500 text-white font-bold py-3 px-6 rounded" @click="savePicturesOrder">
          <div v-if="form.processing" class="btn-spinner mr-2" />
          {{ form.processing ? "Salvando fotos" : "Salvar fotos" }}
        </button>
        <!-- <button  class="">Salvar Fotos</button> -->
      </div>
    </div>
    <!-- <div class="list-group col-md-3">
      <pre>{{ listString() }}</pre>
    </div> -->
  </div>
</template>

<script>
import Icon from "@/Shared/Icon";
import Layout from "@/Shared/Layout";
import TextInput from "@/Shared/TextInput";
import TextAreaInput from "@/Shared/TextAreaInput";
import SelectInput from "@/Shared/SelectInput";
import LoadingButton from "@/Shared/LoadingButton";
import TrashedMessage from "@/Shared/TrashedMessage";
import { VueEditor } from "vue2-editor";
import YearCalendar from "vue-material-year-calendar";
import draggable from "vuedraggable";

const YEAR = new Date().getFullYear();
const NEXTYEAR = YEAR + 1;

export default {
  metaInfo() {
    return { title: this.form.nombre };
  },

  components: {
    Icon,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    TextAreaInput,
    VueEditor,
    YearCalendar,
    draggable
  },
  layout: Layout,
  props: {
    property: Object,
    users: Array,
    prices: Object,
    photos: Array,
    calendar: Object
  },
  remember: "form",
  data() {
    return {
      pictureForm: this.$inertia.form({
        picture: null
      }),
      tab: 0,
      year: YEAR,
      actionYear: new Date().getFullYear(),
      nextYear: NEXTYEAR,
      showYearSelector: false,
      // pictures: ,
      pictures: this.photos.map((data, index) => {
        return { ...data, intOrder: index + 1 };
      }),
      list: ["Foo", "Bar", "Baz"],
      customToolbar: [
        [{ header: [false, 2] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons

        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],

        ["link"],
        ["clean"] // remove formatting button,
      ],
      internalPrices: {
        nov: this.prices && this.prices.nov ? this.processPriceCalendar(this.prices.nov) : ["", "", "", "", ""],
        dic: this.prices && this.prices.dic ? this.processPriceCalendar(this.prices.dic) : ["", "", "", "", ""],
        ene: this.prices && this.prices.ene ? this.processPriceCalendar(this.prices.ene) : ["", "", "", "", ""],
        feb: this.prices && this.prices.feb ? this.processPriceCalendar(this.prices.feb) : ["", "", "", "", ""],
        mar: this.prices && this.prices.mar ? this.processPriceCalendar(this.prices.mar) : ["", "", "", "", ""],
        abr: this.prices && this.prices.abr ? this.processPriceCalendar(this.prices.abr) : ["", "", "", "", ""],
        baja: ["", ""],
        alta: ["", ""],
        carnaval: ["", ""],
        turismo: ["", ""]
      },
      // activeDates: ['2021-01-01', '2021-01-01', '2021-01-02', '2021-01-03', '2021-01-01'],
      activeDates: this.calendar ? this.processCalendar(this.calendar) : [],
      form: this.$inertia.form({
        nombre: this.property.nombre,
        desactivada: this.property.desactivada,
        whatsapp: this.property.whatsapp,
        patrocinada: this.property.patrocinada,
        ID_duenio: this.property.ID_duenio,
        parrillero: this.property.parrillero,
        tipo_inmueble: this.property.tipo_inmueble,
        operacion: this.property.operacion,
        mapongo: this.property.mapongo,
        mascotas: this.property.mascotas,
        zona: this.property.zona,
        descripcion: this.formatPerMe(this.property.descripcion),
        descripcion_corta: this.formatPerMe(this.property.descripcion_corta),
        informe_contacto: this.property.informe_contacto,
        email_contacto: this.property.email_contacto,
        capacidad: this.property.capacidad,
        dormitorios: this.property.dormitorios,
        banios: this.property.banios,
        wifi: this.property.wifi,
        direct: this.property.direct,
        aire: this.property.aire,
        piscina: this.property.piscina,
        banio_suite: this.property.banio_suite,
        sabanas: this.property.sabanas,
        estufa: this.property.estufa,
        cerco: this.property.cerco,
        cubiertos: this.property.cubiertos,
        jacuzzi: this.property.jacuzzi,
        alarma: this.property.alarma,
        rejas: this.property.rejas,
        lavarropas: this.property.lavarropas,
        cochera: this.property.cochera,
        cofre: this.property.cofre,
        alquiler_alta: this.property.alquiler_alta,
        alquiler_baja: this.property.alquiler_baja,
        vista_mar: this.property.vista_mar,
        jovenes: this.property.jovenes,
        oceanview: this.property.oceanview,
        cheap: this.property.cheap,
        architecture: this.property.architecture,
        featured: this.property.featured,
        nature: this.property.nature
      })
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    createObjectURL(preloader) {
      return URL.createObjectURL(preloader);
    },
    changeTab(t) {
      this.tab = t;
      //th
    },
    formatPerMe(desc) {
      desc = desc.replace(/<\/?span[^>]*>/g, "");
      desc = desc.replace(/<\/?div[^>]*>/g, "");
      return desc;
    },
    onUpdate: function(event) {
      this.list.splice(event.newIndex, 0, this.list.splice(event.oldIndex, 1)[0]);
    },
    processPriceCalendar: month => {
      return month.split("|");
    },
    savePicturesOrder() {
      let newPictures = this.pictures.map((data, index) => {
        return { ...data, intOrder: index + 1 };
      });
      console.log(newPictures);
      this.form
        .transform(data => ({
          //...data,
          pictures: newPictures
        }))
        .post("/changeorder", {
          onSuccess: page => {
            // let _this = this;
            // console.log(this.pictureForm.reset());
            // console.log(page);
            // _this.pictures = page.props.photos.map((data, index) => {
            // return { ...data, intOrder: index + 1 };
            // });
          }
        });
    },
    processCalendar: calObj => {
      // Current Year
      let year = YEAR;
      let nextYear = NEXTYEAR;
      let calendarArray = [];
      // Process this year
      console.log(calObj);
      if (calObj[`_${year}`]) {
        let calendar = calObj[`_${year}`].slice(1, -1);
        calendar.split(";;").forEach(dateVal => {
          let dateMont = dateVal.split("-");
          let day = dateMont[0].length == 1 ? "0" + dateMont[0] : dateMont[0];
          let month = dateMont[1].length == 1 ? "0" + dateMont[1] : dateMont[1];
          let finalDate = `${year}-${month}-${day}`;
          const dateObj = { date: finalDate };
          calendarArray.push(dateObj);
        });
      }
      // process next year TODO: Move to for each or a custom function
      if (calObj[`_${nextYear}`]) {
        let calendar = calObj[`_${nextYear}`].slice(1, -1);
        calendar.split(";;").forEach(dateVal => {
          let dateMont = dateVal.split("-");
          let day = dateMont[0].length == 1 ? "0" + dateMont[0] : dateMont[0];
          let month = dateMont[1].length == 1 ? "0" + dateMont[1] : dateMont[1];
          let finalDate = `${nextYear}-${month}-${day}`;
          const dateObj = { date: finalDate };
          calendarArray.push(dateObj);
        });
      }

      console.log(calendarArray);
      return calendarArray;
    },

    toggleDate(dateInfo) {
      console.log(dateInfo); // { date: '2010-10-23', selected: true }
    },
    setYear(year) {
      this.year = year;
      // console.log(this.activeDates)  // { date: '2010-10-23', selected: true }
    },
    saveCalendar() {
      let yearValuesFormated = "";
      let nextYearValuesFormated = "";
      let activeD = this.activeDates;
      // console.log(activeD);
      activeD.forEach(savedDate => {
        let internalDate = savedDate.date || savedDate;
        let year = internalDate.substring(0, 4);
        let arrayDate = internalDate.split("-");
        // console.log(year);
        if (year == YEAR) {
          yearValuesFormated += `;${arrayDate[2]}-${arrayDate[1]};`;
        } else if (year == NEXTYEAR) {
          nextYearValuesFormated += `;${arrayDate[2]}-${arrayDate[1]};`;
        }
      });

      let calendar;
      // if (yearValuesFormated || nextYearValuesFormated) {
      calendar = {};
      calendar.ID_propiedad = this.property.ID;
      calendar.ID_duenio = this.property.ID_duenio;
      // if (yearValuesFormated) {
      calendar["" + YEAR.toString()] = yearValuesFormated || "";
      // }
      // if (nextYearValuesFormated) {
      calendar["" + NEXTYEAR.toString()] = nextYearValuesFormated || "";
      // }
      // }
      //   console.log(calendar);
      // if (calendar) {
      console.log(calendar);
      // nextYearValuesFormated
      this.form
        .transform(data => ({
          // ...data,
          ...calendar
        }))
        .put(this.route("properties.updateCalendar", this.property.ID));
      // }
    },
    uploadImage() {
      let propId = this.property.ID;
      console.log(this.pictureForm);
      this.pictureForm
        .transform(data => ({
          ...data,
          ID_inmueble: propId
        }))
        .post("/upload", {
          onSuccess: page => {
            let _this = this;
            this.pictureForm.reset();
            // console.log(page);
            _this.pictures = page.props.photos.map((data, index) => {
              return { ...data, intOrder: index + 1 };
            });
          }
        });

      // this.pictureForm.post('/upload', this.pictureForm, {
      //     preserveScroll: true,
      //       // onStart: visit => {
      //       //     this.errors.clear();
      //       // },
      //       onSuccess: page => {
      //         alert('page');
      //           if (!this.errors.any()) {
      //               this.pictureForm.reset('picture');
      //           }
      //       },

      //   })
    },
    savePrices() {
      let price = {};

      Object.keys(this.internalPrices).forEach(key => {
        price[key] = "";
        let concatValues = "";
        this.internalPrices[key].forEach(element => {
          concatValues += element.toString() + "|";
        });
        // Remove the latest | to preserve the same format on empty states ||||
        price[key] = concatValues.slice(0, -1);
        price.ID_propiedad = this.property.ID;
        price.ID_duenio = this.property.ID_duenio;
      });
      console.log(price);
      this.form
        .transform(data => ({
          // ...data,
          ...price
        }))
        .put(this.route("properties.updatePrice", this.property.ID));
      // array.for(element => {

      // });
    },
    update() {
      this.form
        .transform(data => ({
          ...data,
          alquiler_alta: this.form.alquiler_alta || "no",
          alquiler_baja: this.form.alquiler_baja || "no",
          mapongo: this.form.mapongo || "-"
        }))
        .put(this.route("properties.update", this.property.ID));
    },
    destroy() {
      if (confirm("Are you sure you want to delete this organization?")) {
        console.log(this.property.ID);
        this.$inertia.delete(this.route("properties.destroy", this.property.ID));
      }
    },
    deletePicture(imageId) {
      let _this = this;
      if (confirm("Esta seguro de borrar la foto?")) {
        console.log(imageId);
        this.$inertia.delete(this.route("picture.destroy", imageId), {
          onSuccess: page => {
            _this.pictures = page.props.photos.map((data, index) => {
              return { ...data, intOrder: index + 1 };
            });
            console.log(page, imageId);
          }
        });
      }
    }
  }
};
</script>
<style>
.picturehome {
  background: #c3e8f8;
  padding: 20px;
  position: relative;
  border-radius: 8px;
}

.picturehome button {
  position: absolute;
  right: 16px;
  bottom: 16px;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.2;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>
